import React from 'react';
import './Content.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function Content(props) {
    const history = useHistory();

    return (
        <div styleName="content">
            {props?.content?.image && (
                <div styleName="image-wrapper">
                    <img alt="school" src={props?.content?.image} />
                </div>
            )}
            <div styleName="text-wrapper">
                <h3>{props?.content?.text}</h3>
                <p>{props?.content?.description}</p>
            </div>
            {props?.showButton && (
                <Button
                    onClick={() =>
                        history.push(
                            `/test/extra-informatie-popup/${props?.content?.answerLabel}`
                        )
                    }
                    color="blue-gray"
                >
                    Meer informatie <FontAwesomeIcon icon={faInfoCircle} />
                </Button>
            )}
        </div>
    );
}
